import { useEffect, useState } from "react";
export const useDetailFormState = () => {
    const [messages, setMessages] = useState({});
    const [saveState, setSaveState] = useState(null);
    useEffect(() => {
        if (saveState === "saved") {
            setTimeout(() => {
                reset();
            }, 2000);
        }
    }, [saveState]);
    useEffect(() => {
        if (messages.success) {
            setSaveState("saved");
        }
        else if (messages.failed) {
            setSaveState("failed");
        }
        else if (messages.errors) {
            setSaveState("errors");
        }
    }, [messages, setSaveState]);
    const reset = () => {
        setSaveState(null);
        setMessages({});
    };
    return { messages, saveState, setMessages, setSaveState, reset };
};
